/**
 * The frequency *scale* for the limiting-span views. Colors live in the theme
 * (`palette.spanFrequency`); this file only decides which band a value falls in.
 */

// Upper bound of each ramp band. One shorter than the ramp: anything above the
// last limit is the top band.
const BAND_LIMITS = [0.25, 0.45, 0.65, 0.8, 0.95]

// Square root, so low-frequency spans don't collapse into the bottom band.
export const getIntensity = (pct: number, maxPct: number): number =>
  Math.sqrt(pct / maxPct)

// Above this a span counts as a frequent limiter and gets lit on the map.
export const LIMITING_INTENSITY_THRESHOLD = 0.25

/**
 * Ramp index for an intensity (0–1), or -1 for no frequency at all — that one is
 * the theme's `none` color rather than a band of the ramp.
 */
export const bandFor = (intensity: number): number => {
  if (intensity <= 0) return -1
  const band = BAND_LIMITS.findIndex((limit) => intensity <= limit)
  return band === -1 ? BAND_LIMITS.length : band
}
